import React, { useEffect, useRef } from 'react';
import { PlayCircle } from '@mui/icons-material';

export function VideoWithPlaceholder({ src, className, controls = "", onClick, autoPlay = "", isCurrent, isCarousel = false, id }) {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            if (isCurrent) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    }, [isCurrent]);

    const containerDiv = isCarousel ? 'd-flex justify-content-center align-items-center h-100' : 'position-relative';

    return (
        <div className={containerDiv} onClick={onClick} id={id}>
            <video
                ref={videoRef}
                className={className}
                controls={controls}
                autoPlay={autoPlay}
                preload="auto"
            >
                <source type="video/mp4" src={src} />
            </video>
            {!isCarousel && <PlayCircle
                className="position-absolute top-50 start-50 translate-middle bg-primary text-tertiary rounded-circle cursor-pointer z-1000"
                fontSize="large"
            />}
        </div>
    );
}